import gql from 'graphql-tag';

export const CART_FRAGMENT = gql`
  fragment CartDonePage on CheckoutSession {
    cart {
      paymentId
      returnUrl {
        href
        pathname
      }
      cancelUrl {
        href
        pathname
      }
      intent
      items {
        quantity
        name
        sku
        unitPrice {
          currencyValue
          currencyFormat
        }
        itemOptionSelections {
          name
          description
        }
      }
      amounts {
        subtotal {
          currencyCode
          currencyFormat
          currencyValue
        }
        tax {
          currencyCode
          currencyFormat
          currencyValue
        }
        shipping {
          currencyCode
          currencyFormat
          currencyValue
        }
        insurance {
          currencyCode
          currencyFormat
          currencyValue
        }
        handlingFee {
          currencyCode
          currencyFormat
          currencyValue
        }
        total {
          currencyCode
          currencyFormat
          currencyFormatSymbolISOCurrency
          currencyValue
        }
        discount {
          currencyCode
          currencyFormat
          currencyValue
        }
      }
    }
  }
`;
